import { render, staticRenderFns } from "./ColumnManager.vue?vue&type=template&id=3a8b4c1e&scoped=true"
import script from "./ColumnManager.vue?vue&type=script&lang=ts"
export * from "./ColumnManager.vue?vue&type=script&lang=ts"
import style0 from "./ColumnManager.vue?vue&type=style&index=0&id=3a8b4c1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8b4c1e",
  null
  
)

export default component.exports